import { useDispatch } from 'react-redux';

import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Button } from '@vk-hr-tek/ui/Button';
import { useQuery } from '@vk-hr-tek/core/query';
import { useIsDesktop } from '@vk-hr-tek/ui/hooks';
import { AuthGreeting } from '@vk-hr-tek/ui/graphics';

import { AuthSourceLogo, Page } from '../../../segments';
import {
  redirectToCandidateLogin,
  setCandidateInviteCode,
} from '../../../slice';
import { CandidateLoginInitDto } from '../../../dto';

export const Greeting = () => {
  const dispatch = useDispatch();
  const isDesktop = useIsDesktop();
  const [{ invite }] = useQuery(CandidateLoginInitDto);

  const authButtonHandler = () => {
    dispatch(setCandidateInviteCode(invite));
    dispatch(redirectToCandidateLogin(invite));
  };

  return (
    <Page title="">
      {!isDesktop && (
        <Box display="flex" justifyContent="center" mb="24">
          <AuthSourceLogo full variant="40" />
        </Box>
      )}

      <Box display="flex" flexDirection="column" alignItems="center">
        <Box mb="40">
          <AuthGreeting />
        </Box>

        <Box mb="12">
          <Typography variant="subtitle1">Добро пожаловать!</Typography>
        </Box>

        <Box mb={{ xs: '56', md: '32' }}>
          <Typography
            variant="body2"
            color="text.light.secondary"
            align="center"
          >
            Процесс оформления пройдет полностью онлайн.
            <br />
            Вы будете получать уведомления, когда от вас будет требоваться
            какое-то действие или информация.
          </Typography>
        </Box>

        <Box width={{ xs: '100%', md: 200 }}>
          <Button fullWidth size="large" onClick={authButtonHandler}>
            Начать
          </Button>
        </Box>
      </Box>
    </Page>
  );
};
